export default "__VITE_ASSET__BbKvtoKt__"